import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit, FaTrash } from "react-icons/fa";
import { itemsActions } from "../../../store/itemStore";

import styles from "./GroceryItem.module.css";
const GroceryItem = (props) => {
  const { id, itemName } = props;
  const groceryItems = useSelector((state) => state.items.groceryItems);
  const isEditing = useSelector((state) => state.items.isEditing);
  const dispatch = useDispatch();
  const history = useHistory();

  const deleteItemHandler = useCallback(
    (id) => {
      const filteredItems = groceryItems.filter((groceryItem) => {
        return groceryItem.id !== id;
      });
      dispatch(itemsActions.onDeleteGroceryItem(filteredItems));
      localStorage.setItem("grocery-bud", JSON.stringify(filteredItems));

      dispatch(
        itemsActions.onChangeReply({
          type: "success",
          message: "item deleted successfully",
        })
      );
    },
    [dispatch, groceryItems]
  );
  const editItemHandler = useCallback(
    (id, itemName) => {
      dispatch(itemsActions.onEditing({ isEditing: true, editDetails: { id, itemName } }));
      history.push(`${history.location.pathname}/${id}`);
    },
    [dispatch, history]
  );
  return (
    <li className={styles["grocery_item"]}>
      <p>{itemName}</p>
      <div className={styles["button_container"]}>
        <button type="button" onClick={() => editItemHandler(id, itemName)} disabled={isEditing}>
          <FaEdit className={styles["icon"]} id={styles["edit-icon"]} />
        </button>
        <button type="button" onClick={() => deleteItemHandler(id)} disabled={isEditing}>
          <FaTrash className={styles["icon"]} id={styles["delete-icon"]} />
        </button>
      </div>
    </li>
  );
};

export default GroceryItem;
